import type { ElementType } from 'react';

import { cx } from '@hrworks/design-system/functions';

import { S } from './IconButton.styles';
import type { IconButtonProps } from './IconButton.types';

export const IconButton = <C extends ElementType = 'button'>({
  corner = 'pill',
  variant = 'filled',
  className,
  ...otherProps
}: IconButtonProps<C>) => (
  <S.Button className={cx(S.cls.Button, className)} corner={corner} variant={variant} {...otherProps} />
);
